export default __webpack_public_path__ + "9280894136d683912c71dc0cfb843fad.png";